module.exports = __webpack_public_path__ + "70adf5a2199a06d048a69d47b8262cff.png";